/**
 * Deterministic camo avatars from a seed (customer id).
 * Same seed → same pattern; different customers → different patterns.
 */
(function () {
  const CAMO_PALETTES = [
    // woodland
    ['#2a3422', '#3d4f2f', '#5c6e42', '#7d8f5c', '#9a8f6a'],
    // desert
    ['#2e2820', '#4a4035', '#6b5d4a', '#8f7d62', '#b5a48a'],
    // urban
    ['#252825', '#3a3f3a', '#555c55', '#737a73', '#a0a89a'],
    // night / blue-grey
    ['#1e2830', '#2f3d4a', '#4a5c6e', '#6a7d8f', '#8a9aaa'],
    // arid / khaki
    ['#302a1e', '#4a3f2f', '#6e5c3a', '#8f7a4a', '#b5a070'],
    // snow / alpine
    ['#3a4248', '#5a656c', '#8a9399', '#c4c9cc', '#e8ebed'],
  ];

  function hashSeed(seed) {
    const str = String(seed);
    let h = 2166136261;
    for (let i = 0; i < str.length; i += 1) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      let t = (a += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function createCamoDataUrl(seed, size) {
    const px = Math.max(32, size || 64);
    const hash = hashSeed(seed);
    const rng = mulberry32(hash);
    const palette = CAMO_PALETTES[hash % CAMO_PALETTES.length];
    const canvas = document.createElement('canvas');
    canvas.width = px;
    canvas.height = px;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = palette[0];
    ctx.fillRect(0, 0, px, px);

    const grid = 8 + (hash % 3);
    const cell = Math.ceil(px / grid);
    for (let y = 0; y < grid; y += 1) {
      for (let x = 0; x < grid; x += 1) {
        if (rng() < 0.68) {
          ctx.fillStyle = palette[1 + Math.floor(rng() * (palette.length - 1))];
          const blockWidth = rng() < 0.2 ? 2 : 1;
          const blockHeight = rng() < 0.14 ? 2 : 1;
          ctx.fillRect(x * cell, y * cell, blockWidth * cell, blockHeight * cell);
        }
      }
    }

    return canvas.toDataURL('image/png');
  }

  function applyCamoToElement(el) {
    const seed = el.getAttribute('data-camo-seed');
    if (!seed || el.dataset.camoApplied === 'true') return;
    const size = parseInt(el.getAttribute('data-camo-size') || '64', 10);
    const url = createCamoDataUrl(seed, size);
    el.style.backgroundImage = `url(${url})`;
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
    el.dataset.camoApplied = 'true';
  }

  function applyAllCamoAvatars(root) {
    (root || document).querySelectorAll('[data-camo-seed]').forEach(applyCamoToElement);
  }

  window.ConcealCamo = {
    createCamoDataUrl,
    applyAllCamoAvatars,
  };

  document.addEventListener('DOMContentLoaded', () => applyAllCamoAvatars());
  document.addEventListener('shopify:section:load', () => applyAllCamoAvatars());
})();
